import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import ReactStars from "react-stars";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { addProductReview } from "../../api.services.js/reviews";
import { useState } from "react";
import { event } from "jquery";

// mutation ($entityPkValue: String!, $entityType: String!, $nickname: String!, $title: String!, $detail: String!, $ratingId: Int!, $value: Int!, $imageName: String!, $imageFile: String!) {

function AddReviews(props) {
  const [file, setFile] = useState("");
  const [name, setName] = useState("");
  const [review, setReview] = useState("");
  const [rating, setRating] = useState(0);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const addReview = async (event) => {
    setError("");
    event.preventDefault();
    if (!name) {
      setError("Name is required.");
      return;
    }
    if (!review) {
      setError("Review is required.");
      return;
    }
    setSubmitting(true);
    let obj = {
      entityPkValue: props.productId,
      entityType: "product",
      nickname: name,
      title: review,
      detail: review,
      ratingId: 1,
      value: rating,
      imageName: "",
      imageFile: "",
    };
    if (localStorage.getItem("userToken")) {
      obj = {
        ...obj,
        token: AES.decrypt(
          localStorage.getItem("userToken"),
          process.env.NEXT_PUBLIC_SECRET_KEY
        ).toString(),
      };
    }
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async function () {
        obj = {
          ...obj,
          imageName: file.name,
          imageFile: reader.result.split(",")[1],
        };

        let response = await addProductReview(obj);
        if (response.data.submitReview.message) {
          swal(`${response.data.submitReview.message}`);
          setSubmitting(false);
        }
      };
      reader.readAsDataURL(file);
    } else {
      let response = await addProductReview(obj);
      if (response.data.submitReview.message) {
        swal(`${response.data.submitReview.message}`);
        setSubmitting(false);
      }
    }
  };
  return (
    <Form onSubmit={(e) => addReview(e)}>
      <div className="your_rating_css_div flex-css">
        <div className="mb-3 your_rating_css">
          <p>Your Rating</p>

          <ReactStars
            count={5}
            value={rating}
            onChange={ratingChanged}
            edit={true}
            color2={"#ff5e00"}
          />
        </div>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Control
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>
      </div>
      <FloatingLabel controlId="floatingTextarea2">
        <Form.Control
          as="textarea"
          placeholder="Your Message"
          style={{ height: "150px" }}
          value={review}
          onChange={(e) => setReview(e.target.value)}
        />
      </FloatingLabel>
      <div className="review_pro_custom_file flex-css">
        <div>
          <label for="upload-photo">+ Add Review Images</label>
          <input
            type="file"
            name="photo"
            id="upload-photo"
            onChange={(e) => setFile(e.target.files[0])}
          />
        </div>

        <Button
          variant="primary"
          type="Submit Review"
          onClick={addReview}
          disabled={submitting}
        >
          {submitting ? "Submitting" : "Submit Review"}
        </Button>
        {error && <p className="error text-danger">{error}</p>}
      </div>
    </Form>
  );
}

export default AddReviews;
